"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGenesysWidgetSettings = void 0;
/**
 * Returns settings for Genesys widget.
 *
 * @returns {GenesysWidgetSettings} - Settings applicable to Genesys Widget SPA.
 */
const getGenesysWidgetSettings = args => {
  const {
    buttonLabel,
    currentLanguage,
    data
  } = args;
  return {
    ButtonLabel: buttonLabel,
    ConsultantNumber: data.customer?.consultantNumber ?? null,
    DataURL: data.chat?.genesys?.configuration?.dataUrl ?? null,
    DedicatedPage: false,
    DeploymentId: data.chat?.genesys?.configuration?.deploymentId ?? '',
    Email: data.customer?.emails?.[0]?.emailAddress ?? null,
    FirstName: data.customer?.firstName ?? null,
    Language: currentLanguage,
    LastName: data.customer?.lastName ?? null,
    OrganizationId: data.chat?.genesys?.configuration?.organizationId ?? '',
    PhoneNumber: data.customer?.phones?.find(phone => phone?.isPrimary && phone.isVerified)?.telephoneNumber ?? null,
    PluginsPath: data.chat?.genesys?.configuration?.pluginsPath ?? '',
    Queue: data.chat?.genesys?.configuration?.queue ?? '',
    ScriptURL: data.chat?.genesys?.configuration?.scriptUrl ?? '',
    Title: data.customer?.title ?? ''
  };
};
exports.getGenesysWidgetSettings = getGenesysWidgetSettings;
